// extracted by mini-css-extract-plugin
export default {"wrapper":"FilterPanel_wrapper__E0p0h"};